import useSWR from 'swr';

const useAuthors = ({ id, pagination = true, page = 1, pageSize = 20, search, roles, memberships, status, isForeign }) => {
  const url = id ? `/authors/${id}` : `/authors`;

  const params = new URLSearchParams({
    pagination,
    page,
    itemsPerPage: pageSize,
    ...(search && { searchKey: search }),
    ...(status && { status }),
    // Tablo filtresi tek seçimli dizi verir (`[true]` / `[false]`); `false` da geçerli bir filtre değeri.
    ...(isForeign?.length && { isForeign: isForeign[0] }),
  });

  roles?.forEach((role) => params.append('user.roles[]', role));
  memberships?.forEach((membership) => params.append('user.memberships.committee.shortName[]', membership));

  const { data, error } = useSWR(`${url}?${params.toString()}`, {
    revalidateOnFocus: true,
  });

  return {
    data,
    isLoading: !error && !data,
    isError: error,
  };
};

export default useAuthors;
